module.exports = __webpack_public_path__ + "static/media/galerija_2016 (3).7eca986f.jpg";